/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

// import moduleECommerce from './eCommerce/moduleECommerce.js'
import moduleMenu from './menu/moduleMenu.js'
import moduleNotification from './notification/moduleNotification.js'
import moduleAlarm from './alarm/moduleAlarm.js'

/* Modules */
import User from './modules/User'
import Branch from './modules/Branch'
// Master
import VehicleBrand from './modules/master/VehicleBrand'
import VehicleType from './modules/master/VehicleType'
import VehicleList from './modules/master/VehicleList'
import RefAlert from './modules/master/RefAlert'
import GpsType from './modules/master/GpsType'
import Command from './modules/master/Command'
import Imei from './modules/master/Imei'
import PoiIcon from './modules/master/PoiIcon'
import VehicleIcon from './modules/master/VehicleIcon'
// Setting
import ImeiAssignment from './modules/setting/ImeiAssignment'
import Permission from './modules/setting/Permission'
import Menu from './modules/setting/Menu'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    // eCommerce: moduleECommerce,
    menu: moduleMenu,
    notification: moduleNotification,
    alarm: moduleAlarm,

    /* Page modules */
    User,
    Branch,
    /* Master Data */
    VehicleBrand,
    VehicleType,
    VehicleList,
    RefAlert,
    GpsType,
    Command,
    Imei,
    PoiIcon,
    VehicleIcon,
    /* Setting */
    ImeiAssignment,
    Permission,
    Menu
  },
  strict: process.env.NODE_ENV !== 'production'
})
